import { render, staticRenderFns } from "./Navigation.vue?vue&type=template&id=3c19de1c"
import script from "./navigation.ts?vue&type=script&lang=ts&external"
export * from "./navigation.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports